import React, { useContext } from 'react'
import { Button, Typography } from "mobily-ui-library/lib";
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../context/GlobalContext';

import { changeDateFormat } from '../../utils';
import './RequestLists.scss';

function RequestLists() {
    const { t } = useTranslation();

    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, requestLists } = state;

    const handleRequestDetails = (requestList: any) => {
        dispatch({ type: 'UPDATE_REQUEST_DETAILS', payload: requestList });
        dispatch({ type: 'UPDATE_PAGE', payload: 'requestDetails' });
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
    }

    return (
        <main className='FTTH__ReqListContainer'>
            <div className='RL_Section'>
                <section className='RL_HeadingSection'>
                    <div className='RL_Subheading'>
                        <Typography className='TO_title mb-2'>{t('Your_FTTH_Coverage_requests')}</Typography>
                    </div>
                    <div className='d-flex flex-column gap-4'>
                        {requestLists?.map((requestList: any) => {
                            const zoneCategory = requestList.ZoneCategory;
                            const zoneCategorySLA = requestList.ZoneCategorySLA;

                            const status = requestList.OrderStatus.toLowerCase();
                            const colors = status === 'cancelled' ? "#DB4076" : status === 'completed' ? "#40CFB3" : "#51565B";
                            const fontWeight = status === 'cancelled' ? "600" : status === 'completed' ? "600" : "500";
 
                            return (
                                <React.Fragment key={requestList.MobilyOrderNumber}>
                                    <div className='ReqList_Section'>
                                        <div className='OrderNumber__Card'>
                                            <Typography rtl={rtl} className='ONC__text'>{t('Order_number')}</Typography>
                                            <Typography rtl={rtl} className='ONC__value'>{requestList?.MobilyOrderNumber}</Typography>
                                        </div>

                                        <div className='OrderNumber__Card'>
                                            <div className='d-flex gap-1'>
                                                <Typography rtl={rtl} className='ONC__text' >{t('Requested')}</Typography>
                                                <Typography rtl={rtl} className='ONC__status' >{changeDateFormat(requestList?.RequestDate) || 'DD-MM-YYYY'}</Typography>
                                            </div>

                                            <div className='d-flex gap-1'>
                                                <Typography rtl={rtl} className='ONC__text'>{t('Status')}</Typography>
                                                <Typography rtl={rtl} className='ONC__status' color={colors} fontWeight={fontWeight}>{status === 'in-progress' ? `${t('Awaiting_delivery')}*` : t(requestList.OrderStatus)}</Typography>
                                            </div>
                                        </div>

                                        <div className=''>
                                            <Button
                                                primary={true}
                                                rtl={rtl}
                                                variant={'default'}
                                                htmlType={'submit'}
                                                className='details-btn'
                                                onClick={() => handleRequestDetails(requestList)}
                                            >
                                                {t('DETAILS')}
                                            </Button>
                                        </div>
                                    </div>
                                    {status === 'in-progress' && (
                                        <Typography rtl={rtl} className='ONC__service'>
                                            {`*${t('Service_connectivity')} ${zoneCategorySLA} ${zoneCategory === 'A' ? t('days_from_submission') : t('days_after_collecting')}`}
                                        </Typography>
                                    )}
                                </React.Fragment>
                            )
                        })}
                    </div>
                </section>
            </div>
        </main>
    )
}

export default RequestLists